import React from 'react';
import BenefitForm from 'forms/BenefitForm';

export default (): JSX.Element => <BenefitForm />;
